import React from 'react';

import Button from '@mui/material/Button';

import styled from '../../../styled';
import { colorsPalette } from '../../../theme';

interface IconButtonProps {
  className?: string;
  label?: string;
  icon: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
  size: 'small' | 'medium' | 'large';
}

const IconButton: React.FC<IconButtonProps> = ({
  icon,
  label,
  className,
  onClick,
  disabled = false,
  ...rest
}) => {
  return (
    <StyledButton disabled={disabled} className={className} onClick={onClick} {...rest}>
      {icon}
      <ButtonLabel className={'buttonLabel'}>{label}</ButtonLabel>
    </StyledButton>
  );
};

export default IconButton;

const StyledButton = styled(Button)`
  padding: 0;
  line-height: 1;
  font-weight: 700;
  text-decoration: none;
  font-size: 14px;
  position: relative;
  color: ${({ theme }) => theme.palette.primary.light};
  border-radius: 0;
  transition: 0.1s ease all;
  display: flex;

  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: 16px;
  }

  &:hover {
    background: transparent;
    & .buttonLabel {
      color: ${({ theme }) => theme.palette.primary.light};
    }
  }
`;
const ButtonLabel = styled('span')`
  margin-left: 6px;
  color: ${colorsPalette.white};
`;
